<template>
    <Layout>
        <template slot="body">
            <div class="card card-modern pt-3" style="border: none; box-shadow: none;">
                <div class="modern-header" style="display: flex; align-items: center; gap: 15px; margin-bottom: 20px;">
                    <div class="header-icon" style="background: #fff7ed; color: #ff9800; width: 48px; height: 48px; border-radius: 12px; display: flex; align-items: center; justify-content: center;">
                        <i class="material-icons" style="font-size: 24px; margin: 0;">description</i>
                    </div>
                    <h4 class="card-title" style="margin: 0; font-size: 1.5rem; color: #1e293b;">Calcular competitividade</h4>
                </div>
                <div class="card-body">
                    <button id="buttonGerar" v-on:click="gerarAnalise" style="width: 200px;" class="btn-solar">CALCULAR</button>

                    <div v-show="success" class="mt-3" style="margin: auto;">
                        <span style="font-weight: bold; margin: auto;">Cálculo concluido com sucesso!</span>
                    </div>

                    <div v-show="errors" class="mt-3">
                        <ul>
                            <li v-for="(error, i) in errors" :key="i">
                                <span style="font-weight: bold; color: red;">{{ error }}</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </template>
    </Layout>
</template>

<script>

    import Layout from "@/components/layout/Layout.vue";

    export default {
        data() {
            return {
                success: false,
                errors: null,
                formData: {
                    quantidade_cidades: 0
                }
            }
        },
        methods: {
            gerarAnalise() {
                document.getElementById("buttonGerar").disabled = true;
                document.getElementById("buttonGerar").innerText = "CALCULANDO";

                this.calcularAnalise();
            },
            calcularAnalise() {
                callAPI(
                    "/importacao/calcular-competitividade",
                    "post",
                    this.formData,
                    (res) => {
                        if ( res.next >= 0 ) {
                            this.formData.quantidade_cidades = res.next;
                            this.calcularAnalise();
                        } else {
                            if ( res.success ) {
                                this.success = true;
                                this.errors = null;
                            } else {
                                this.success = false;
                                this.errors = res.errors;
                            }

                            this.formData.quantidade_cidades = 0;

                            document.getElementById("buttonGerar").disabled = false;
                            document.getElementById("buttonGerar").innerText = "CALCULAR";
                        }
                    }
                );
            }
        },
        components: {
            Layout
        },
    };
</script>